import React, { useEffect, useRef, useState } from 'react';
import SEO from '../utils/SEO';
import BannerBlock from '../components/complex/bannerBlock/bannerBlock';
import '../assets/styles/pages/_donate.scss';
import { startLoader } from '../components/common/Loader';
import { userActions } from '../redux/actions';
import { connect } from 'react-redux';

const Donate = ({ getDonationData, ...props }) => {
  const [openDonatePopup, setOpenDonatePopup] = useState(false);
  const [donateSuccess, setDonateSuccess] = useState(false);
  const [checkedCurrency, setCheckedCurrency] = useState('USD');
  const [checkedAmount, setCheckedAmount] = useState(undefined);
  const customInputRef = useRef(null);
  const [banner, setBanner] = useState(null);
  const [donatedAmount, setDonatedAmount] = useState('0');
  const [donatedCurrency, setDonatedCurrency] = useState('USD');

  const showPopup = (success, amount, currency) => {
    amount && setDonatedAmount(amount);
    currency && setDonatedCurrency(currency);
    setOpenDonatePopup(true);
    setDonateSuccess(success);
  };

  useEffect(() => {
    props.getMeta('Donate');
    startLoader();

    const donateResult = new URLSearchParams(props.location.search).get(
      'donate'
    );
    const donateCurrency = new URLSearchParams(props.location.search).get(
      'currency'
    );
    const donateAmount = new URLSearchParams(props.location.search).get(
      'amount'
    );

    if (donateResult) {
      donateResult === 'success'
        ? showPopup(true, donateAmount, donateCurrency)
        : showPopup(false);
    }

    getDonationData().then((response) => {
      setBanner(response.res.banner);
    });
  }, [getDonationData, props.location.search]);

  const closePopup = () => {
    setOpenDonatePopup(false);
  };

  const selectAmount = (amount) => {
    customInputRef.current.value = '';
    setCheckedAmount(amount);
  };

  const currency = [
    {
      name: 'USD',
      symbol: '$',
      amounts: ['10', '20', '50', '100', '500'],
    },
    {
      name: 'EUR',
      symbol: '€',
      amounts: ['10', '20', '50', '100', '500'],
    },
    {
      name: 'GBP',
      symbol: '£',
      amounts: ['10', '20', '50', '100', '500'],
    },
    {
      name: 'RUB',
      symbol: '₽',
      amounts: ['100', '1000', '5000', '10000', '50000'],
    },
  ];

  const seoBanner = props.donations_data?.items?.banner;

  const selectCurrency = (currency) => {
    customInputRef.current.value = '';
    setCheckedAmount(null);
    setCheckedCurrency(currency);
  };

  const setCustomAmount = (e) => {
    const { value } = e.target;
    setCheckedAmount(value);
  };

  const metaData = props.metaData?.res;

  return (
    <>
      <SEO
        title={metaData && metaData.title}
        description={metaData && metaData.description}
        img={metaData && metaData.image}
        keywords={metaData && metaData.key}
      />

      <BannerBlock
        data={banner}
        pageName='donateBanner'
        fullHeight
        scrollTo={{ elementId: 'donation_form' }}
        position='left'
      />
      <div id='donation_form' className='donation_form'>
        <h3>DONATION FORM</h3>
        <p>
          All donations go to the InClassica Dubai International Music Festival
          2022.
          <br />
          Your support is invaluable to us and we appreciate any assistance you
          would like to provide. Thank you for your support!
        </p>
        <div className='donateSection'>
          <p className='labelText'>Currency</p>
          <div className='selectCurrency'>
            {currency &&
              currency.map((item, i) => (
                <label
                  key={i}
                  className={checkedCurrency === item.name ? 'checked' : ''}
                  onClick={() => selectCurrency(item.name)}
                >
                  <p>{item.name}</p>
                  <input type='radio' hidden name='currencyCode' />
                </label>
              ))}
          </div>
          <p className='labelText'>Amount</p>
          <div className='selectAmount'>
            {currency &&
              currency.map(
                (item) =>
                  item.name === checkedCurrency &&
                  item.amounts.map((amount) => (
                    <label
                      key={checkedCurrency + amount}
                      className={checkedAmount === amount ? 'checked' : ''}
                      onClick={() => selectAmount(amount)}
                    >
                      <p>
                        <span>{item.symbol}</span>
                        {amount}
                      </p>
                      <input type='radio' hidden name='amountValue' />
                    </label>
                  ))
              )}
            <input
              onChange={setCustomAmount}
              ref={customInputRef}
              className='customAmount'
              type='number'
              placeholder='OTHER AMOUNT'
              min='1'
              defaultValue=''
            />
          </div>
        </div>
        <form
          className='donateForm'
          action='https://www.paypal.com/donate'
          method='post'
          target='_blank'
        >
          <input type='hidden' name='cmd' value='_donations' />
          <input type='hidden' name='business' value='info@eufsc.eu' />
          <input type='hidden' name='item_name' value='Donate EUFSC' />
          <input type='hidden' name='currency_code' value={checkedCurrency} />
          <input type='hidden' name='amount' value={checkedAmount} />
          <input
            type='hidden'
            name='return'
            value={`https://inclassica.com/donate?donate=success&currency=${checkedCurrency}&amount=${checkedAmount}`}
          />
          <input
            type='hidden'
            name='cancel_return'
            value='https://inclassica.com/donate?donate=fail'
          />
          <input
            className='donateButton'
            type='submit'
            value='DONATE'
            disabled={!checkedAmount || !checkedCurrency}
          />
        </form>
      </div>

      <div
        className={`donatePopup ${openDonatePopup ? 'showPopup' : ''}`}
        id='donatePopup'
      >
        <div className='donatePopupCloseDiv' onClick={closePopup} />

        <div className='donatePopupBody'>
          <div className='donatePopupBodyCloseIcon' onClick={closePopup} />
          {donateSuccess ? (
            <div className='donatePopupBodySuccess'>
              <h3>THANK YOU!</h3>
              <p>
                You successfully donated{' '}
                <span className='donateSize'>
                  {donatedAmount} {donatedCurrency}
                </span>{' '}
                to inclassica international music festival
              </p>
              <button onClick={closePopup}>Done</button>
            </div>
          ) : (
            <div className='donatePopupBodyFailure'>
              <h3>OOPS SOMETHING WENT WRONG!</h3>
              <button onClick={closePopup}>Close</button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

function mapState (state) {
  return {
    donations_data: state.getDonationData,
    metaData: state.getMeta,
  };
}

const actionCreators = {
  getDonationData: userActions.getDonationData,
  getMeta: userActions.getMetaData,
};

Donate.fetchMeta = () => {
  return actionCreators.getMeta('Donate');
};

Donate.serverFetch = actionCreators.getDonationData;

export default connect(mapState, actionCreators)(Donate);
